var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOjiicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 43,
    viewBox: "0 0 73 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_286_13174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8114 0.764857C21.494 0.758068 21.172 0.758068 20.8499 0.764857C9.48993 1.01151 0.2569 10.0292 0.00435247 21.1242C-0.264413 32.9795 9.66833 42.6805 21.8068 42.418C28.804 42.2664 34.9925 38.7883 38.7761 33.5452C38.9985 33.2352 39.214 32.9184 39.4202 32.5971C41.392 29.524 42.5643 25.917 42.6524 22.0587C42.9142 10.518 33.5074 1.0183 21.8114 0.764857ZM20.8013 32.5835C15.0205 32.3232 10.3402 27.7522 10.0761 22.1085C9.77028 15.6344 15.2313 10.303 21.8601 10.5994C27.6409 10.8596 32.3211 15.4307 32.5852 21.0766C32.8911 27.5508 27.43 32.8822 20.8013 32.5857V32.5835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.8055 0.763672V27.6265C57.8055 35.7209 51.0655 42.4214 42.7754 42.4214H39.395V32.5936H42.7754C45.5164 32.5936 47.743 30.4167 47.743 27.7397V0.763672H57.8055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M73.0001 20.415V42.4217H62.9399V10.5918H62.9423L73.0001 20.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.7258 10.5712H62.9399V6.86914C63.9849 6.86914 64.9302 7.28551 65.6137 7.95307C66.2995 8.62289 66.7235 9.54841 66.7235 10.5712H66.7258Z",
    fill: "#48D6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73 10.5914H69.8698C69.8698 8.72002 69.0936 7.02511 67.8355 5.79636C66.5821 4.57213 64.849 3.8118 62.9375 3.8118V0.763672C65.7155 0.763672 68.2317 1.86344 70.0505 3.64208C71.8716 5.42072 72.9977 7.87822 72.9977 10.5914H73Z",
    fill: "#48D6C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M66.7258 10.5712H62.9399V6.86914C63.9849 6.86914 64.9302 7.28551 65.6137 7.95307C66.2995 8.62289 66.7235 9.54841 66.7235 10.5712H66.7258Z",
    fill: "#48D6C6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_13174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 41.6622,
    fill: "white",
    transform: "translate(0 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjiicon);
export default __webpack_public_path__ + "static/media/ojiicon.4f14b3ea97609259246a42df1a5a9eb4.svg";
export { ForwardRef as ReactComponent };